import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ element }) => {
 
  const localToken = localStorage.getItem('userToken');
  const isAuthenticated =  !!localToken;
  const location = useLocation();

  if (!isAuthenticated) {
   
    localStorage.clear();
    sessionStorage.clear();
    return <Navigate to="/" replace state={{ from: location }} />;
  }


  return element;
};

export default ProtectedRoute;
